module.exports = __webpack_public_path__ + "static/media/Food4.fc133f01.jpg";